// Import necessary Material-UI components
import { Grid } from "@mui/material";
// Import custom utilities
import { checkKnownDateOrString } from "../";
// Import lodash for utility functions
import _ from "lodash";

/**
 * ItemRowDetails component for showing a {key: value} pair in supplier details in item details dialog
 * @param {Object} props - Component props including data, and callbacks.
 */
export function ItemRowDetails({ data }) {
  return Object.keys(data).map((oneKey, i) => {
    return (
      <Grid
        container
        key={i}
        style={{
          fontSize: "14px",
          marginBottom: "15px",
        }}
      >
        <Grid item xs={12} sm={5}>
          <span>{_.startCase(Object.keys(data)[i]) + ":"}</span>
        </Grid>

        <Grid item xs={12} sm={7}>
          <span>{checkKnownDateOrString(oneKey, data[oneKey])}</span>
        </Grid>
      </Grid>
    );
  });
}
